import axios from "axios";
import { URL_BASE } from "../config/url-server";


const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")





export const bunchesByDay = async (params) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard-yield/bunches-by-day",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const hectaresByDay = async (params) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard-yield/hectares-by-day",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const totalBunchesAndPalms = async (startDate, endDate,farmId,lotId,sectionId,lots,userId) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots,userId};
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard-yield/total-bunches-and-palms",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const getBunchesByLot = async (startDate, endDate,farmId,lotId,sectionId,lots,userId) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots,userId};
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard-yield/bunches-by-lot",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};


export default {
  hectaresByDay,
  bunchesByDay,
  totalBunchesAndPalms,
  getBunchesByLot
};
